import { DatesProviderSettings } from "@mantine/dates";

export const DATE_PATTERNS = {
  GLOBAL: {
    DATE: "YYYY-MM-DD",
    TIME: "HH:mm",
    DATE_TIME: "YYYY-MM-DD HH:mm"
  },

  BR: {
    DATE: "DD/MM/YYYY",
    TIME: "HH:mm",
    DATE_TIME: "DD/MM/YYYY HH:mm"
  }
} as const;

export const DATE_SETTINGS: DatesProviderSettings = {
  locale: "pt-BR",
  firstDayOfWeek: 1 // Monday
} as const;
